import { render, staticRenderFns } from "./EditInbound.vue?vue&type=template&id=cba5d6ba&scoped=true&"
import script from "./EditInbound.vue?vue&type=script&lang=js&"
export * from "./EditInbound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba5d6ba",
  null
  
)

export default component.exports